import './patchResizeObserver'

import React from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App'
// import reportWebVitals from './reportWebVitals'
import '@fontsource/roboto/300.css'
import '@fontsource/roboto/400.css'
import '@fontsource/roboto/500.css'
import '@fontsource/roboto/600.css'
import '@fontsource/roboto/700.css'

// Suppress benign ResizeObserver / getComputedStyle errors (from Virtuoso, MUI, etc. when tabs unmount)
const isResizeObserverLoop = (message, error) =>
  (typeof message === 'string' && message.includes('ResizeObserver loop')) ||
  (error?.message && String(error.message).includes('ResizeObserver loop'))
const isGetComputedStyleElementError = (message, error) =>
  (typeof message === 'string' && message.includes("getComputedStyle") && message.includes("not of type 'Element'")) ||
  (error?.message && String(error.message).includes("not of type 'Element'"))

window.addEventListener('error', event => {
  if (isResizeObserverLoop(event.message, event.error) || isGetComputedStyleElementError(event.message, event.error)) {
    event.stopImmediatePropagation()
    event.preventDefault()
    return true
  }
}, true)

const prevOnError = window.onerror
window.onerror = function (message, source, lineno, colno, error) {
  if (isResizeObserverLoop(message, error) || isGetComputedStyleElementError(message, error)) {
    return true
  }
  if (error?.message === 'Invalid namespace') {
    if (process.env.NODE_ENV === 'development') {
      console.warn('[Socket] Invalid namespace from server; ignoring to avoid saga cancellation.')
    }
    return true
  }
  return prevOnError ? prevOnError.call(this, message, source, lineno, colno, error) : false
}

// Socket.io can throw "Invalid namespace" inside a promise when server sends a namespaced packet; prevent unhandled rejection from cancelling sagas
window.addEventListener('unhandledrejection', event => {
  if (event?.reason?.message === 'Invalid namespace') {
    if (process.env.NODE_ENV === 'development') {
      console.warn('[Socket] Invalid namespace (unhandledRejection); server may be using a different namespace.')
    }
    event.preventDefault()
  }
})

const container = document.getElementById('root')
const root = createRoot(container)
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals(console.log) // TODO: report web vitals on a reporting service
